import { NetworkActivityTimeframeType, NetworkTopThreadStarterSenderFilter } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import {
  SetAnalyticsSettingsSelectNetworkTimeframe,
  SetAnalyticsSettingsSelectedUserAction,
} from '../../domains/analyticsSettings/actions.types';

import { AnalyticsSettings } from './types';

export type AnalyticsSettingsAction =
  | SetAnalyticsSettingsSelectedUserAction
  | SetAnalyticsSettingsSelectNetworkTimeframe;

const initialState: AnalyticsSettings = {
  selectedOnBehalfOfUserId: undefined,
  networkActivitySettings: {
    timeframe: NetworkActivityTimeframeType.TWENTY_EIGHT_DAYS,
    topThreadStarterSenderFilter: NetworkTopThreadStarterSenderFilter.ALL_USERS,
  },
};

const reducer: Reducer<AnalyticsSettings, AnalyticsSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_SETTING_SELECTED_USER.SET':
      return { ...state, selectedOnBehalfOfUserId: action.payload.selectedOnBehalfOfUserId };
    case 'ANALYTICS_SETTING_SELECT_NETWORK_TIMEFRAME.SET':
      return {
        ...state,
        networkActivitySettings: { ...state.networkActivitySettings, timeframe: action.payload.timeframe },
      };
    default:
      return state;
  }
};

export default reducer;
